<template>
  <v-card
    class=" py-8 px-6 text-center"
    elevation="0">
    <v-card-title> パスワード変更 </v-card-title>

    <v-alert
      type="info"
      variant="tonal"
      class="mb-8 text-left">
      このパスワードは初期パスワードです。<br />
      新しいパスワードを設定してください。
    </v-alert>

    <v-card-text class="mt-4">
      <!-- エラーメッセージ -->
      <v-alert
        v-if="props.error"
        type="error"
        variant="tonal"
        class="mb-8 text-left">
        {{ props.error }}
      </v-alert>

      <v-form
        v-model="sendable"
        ref="loginForm"
        @submit.prevent="submit">
        <v-text-field
          v-model="password"
          :type="passwordVisible ? 'text' : 'password'"
          :append-icon="passwordVisible ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="passwordVisible = !passwordVisible"
          label="新しいパスワード"
          :rules="[rules.required]"
          variant="outlined"
          clearable
          block></v-text-field>

        <v-text-field
          v-model="confirmPassword"
          :type="confirmPasswordVisible ? 'text' : 'password'"
          :append-icon="confirmPasswordVisible ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="confirmPasswordVisible = !confirmPasswordVisible"
          label="新しいパスワード（確認）"
          :rules="[rules.required, rules.confirm]"
          variant="outlined"
          clearable
          block></v-text-field>

        <v-btn
          :loading="loading"
          :disabled="!sendable"
          type="submit"
          class="my-4"
          width="70%"
          variant="flat"
          color="primary"
          size="large"
          block>
          パスワード変更
        </v-btn>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
import { ref } from 'vue';

const props = defineProps({
  loading: Boolean,
  error: String
});

const emit = defineEmits<{
  submit: [password: string];
}>();

const password = ref('');
const confirmPassword = ref('');
const passwordVisible = ref(false);
const confirmPasswordVisible = ref(false);
let sendable = ref(false);

let loading = false;

const rules = {
  required: (value) => !!value || '必須項目です',
  confirm: () => password.value == confirmPassword.value || 'パスワードが一致しません'
};

async function submit() {
  loading = true;
  emit('submit', password.value);
  loading = false;
}
</script>
